export default __webpack_public_path__ + "static/media/actividad-43b.0b48e857.mp3";